/**
 * <s-announcement-rotator> cycles its [data-slide] children one at a time.
 * Interval comes from data-interval (ms, default 5000). Pauses while hovered or focused.
 * Inactive slides get opacity-0 and aria-hidden so only the visible message is read.
 */
class SAnnouncementRotator extends HTMLElement {
  #timer = null;
  #index = 0;
  #paused = false;

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    if (this.slides.length < 2) return;
    this.interval = Number(this.dataset.interval) || 5000;
    this.#show(0);
    this.addEventListener('mouseenter', this.#pause);
    this.addEventListener('mouseleave', this.#resume);
    this.addEventListener('focusin', this.#pause);
    this.addEventListener('focusout', this.#resume);
    this.#start();
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
    this.removeEventListener('mouseenter', this.#pause);
    this.removeEventListener('mouseleave', this.#resume);
    this.removeEventListener('focusin', this.#pause);
    this.removeEventListener('focusout', this.#resume);
  }

  #start() {
    clearInterval(this.#timer);
    this.#timer = setInterval(() => {
      if (!this.#paused) this.#show((this.#index + 1) % this.slides.length);
    }, this.interval);
  }

  #pause = () => { this.#paused = true; };
  #resume = () => { this.#paused = false; };

  #show(next) {
    this.#index = next;
    this.slides.forEach((slide, i) => {
      const active = i === next;
      slide.classList.toggle('opacity-0', !active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }
}

if (!customElements.get('s-announcement-rotator')) {
  customElements.define('s-announcement-rotator', SAnnouncementRotator);
}
